import React from 'react'
import * as Sentry from '@sentry/react'

// No lugar do mapa quando ele não abre (navegador sem WebGL, ou o código do
// mapa não baixou). `children` é o card de ETA, que continua valendo.
export const AvisoSemMapa = ({ children }) => (
  <div style={{ position: 'relative' }}>
    <div
      className="aviso-sem-mapa flex items-start justify-center px-2 pt-3 text-center text-[#8a7778]"
      style={{ height: 220, borderRadius: 16, background: '#FAF8F6' }}
    >
      Não deu pra abrir o mapa neste navegador. O andamento da entrega continua aqui embaixo.
    </div>
    {children}
  </div>
)

// Segura a falha do mapa (ex.: chunk que não baixou em rede ruim) aqui, em vez
// de subir pro boundary global e derrubar a página inteira do pedido.
export class SeOMapaFalhar extends React.Component {
  constructor(props) {
    super(props)
    this.state = { falhou: false }
  }

  static getDerivedStateFromError() {
    return { falhou: true }
  }

  // Pego aqui, o erro não chega mais ao boundary global: avisa o Sentry na mão
  // (o beforeSend já tira o token das URLs).
  componentDidCatch(erro) {
    Sentry.captureException(erro)
  }

  render() {
    if (this.state.falhou) return <AvisoSemMapa>{this.props.aviso}</AvisoSemMapa>
    return this.props.children
  }
}
